export var LeagueIdEnum;
(function (LeagueIdEnum) {
    LeagueIdEnum["League"] = "2eeb48fa-495e-442c-b63c-61d7d17db681";
    LeagueIdEnum["SuperLeague"] = "ec39e5bd-b98b-428e-b9da-12feddeb0b72";
})(LeagueIdEnum || (LeagueIdEnum = {}));
//# sourceMappingURL=league.js.map